// 本地环境配置
module.exports = {
  title: '共创家—共创家web端',
  baseUrl: '', // 项目地址
  baseApi: '/applet', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  $cdn: ''
};
